
/**
 * * 将旧Map转化为新Map,字段一一对应
 * @param oldMap 
 * @param keys
 */
export const useOldMapConvertToNew = <T>(oldMap: T, keys: Array<[oldKey: string, newKey: string]>) => {
    const isArray = oldMap instanceof Array;
    const newMap =  isArray ? oldMap.map(item => {
        return keys.reduce((acc, [oldKey, newKey]) => {
            acc[newKey] = item[oldKey];
            return acc;
        }, {} as any);
    }) : keys.reduce((acc, [oldKey, newKey]) => {
        acc[newKey] = (oldMap as Record<string, unknown>)[oldKey];
        return acc;
    } , {} as any);
    return newMap;
}